'use client'

// @ts-strict-ignore
import clsx from 'clsx'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React from 'react'

import { useRegion } from '@/entities/regions'

import { jsonLD } from '@/shared/integrations/microdata'
import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { unEscape } from '@/shared/lib/utils/string/un-escape'
import { TPage } from '@/shared/types/deprecated-types'

import { getRouteBreadcrumbs } from '../../lib/getRouteBreadcrumbs'

import cl from './Breadcrumbs.module.scss'

export type BreadcrumbsProps = {
	mobileHidden?: boolean
	pages?: TPage[]
}

/**
 * Page navigation
 * @param props
 * @param props.mobileHidden - Whether to hide breadcrumbs on mobile
 */
export const Breadcrumbs = ({ mobileHidden, pages: pagesOverride }: BreadcrumbsProps): JSX.Element => {
	const pathname = usePathname()
	const routePages = getRouteBreadcrumbs(pathname || '/')
	const normalizedPages = (pagesOverride ?? []).filter(({ title }) => !!title?.trim())
	const resolvedPages = normalizedPages.length > 0 ? normalizedPages : routePages

	const { baseUrl } = useRegion()

	return (
		<section className={clsx(cl.root, mobileHidden && cl.mobileHidden)}>
			{/* Breadcrumbs */}
			<script
				type="application/ld+json"
				data-label="Breadcrumbs"
				dangerouslySetInnerHTML={createMarkup(jsonLD.getBreadcrumbsSchema(resolvedPages, baseUrl))}
			/>
			<nav aria-label="Breadcrumb">
				<ol className={cl.list}>
					{/* Home link */}
					<li className={cl.item}>
						<Link prefetch={false} href="/" className={clsx(cl.link, 'gtm-breadcrumb-link')}>
							Главная
						</Link>
						<span className={cl.separator}>/</span>
					</li>
					{/* Other page links */}
					{resolvedPages.map(({ title, link }, index) => {
						const pageTitle = !!title ? unEscape(title) : ''
						const isLast = index === resolvedPages.length - 1

						return (
							<li key={`${link || pageTitle}-${index}`} className={cl.item}>
								{!isLast ? (
									<>
										<Link prefetch={false} href={link} className={clsx(cl.link, 'gtm-breadcrumb-link')}>
											{pageTitle}
										</Link>
										<span className={cl.separator}>/</span>
									</>
								) : (
									<span>{pageTitle?.split(', (')[0].split('(')[0]}</span>
								)}
							</li>
						)
					})}
				</ol>
			</nav>
		</section>
	)
}
